import { useRef, useContext } from "react"
import Header from "../../../../layouts/Header"
import BackIcon from "../../../../components/BackIcon"
import { useNavigate, useLocation } from "react-router-dom"
import { Box, Tooltip, IconButton } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CustomBackdrop from "../../../../components/CustomBackdrop"
import { useMutation, api } from "../../../../api"
import { GlobalContext } from "../../../../contexts/GlobalContext"
import getIconComponent from "../../../utils/getIconComponent"
import FormularioRecintoElectoral from "../componentes/FormularioRecintoElectoral"

// Tema estándar de SIAC
const theme = createTheme({
  palette: {
    primary: { main: "#196C87" },
    secondary: { main: "#2E7D32" },
  },
})

const EditarRecintoElectoral = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { selectedMenuInfo } = useContext(GlobalContext)
  const formRef = useRef()

  // Capturamos la data de la fila seleccionada
  const rowData = location.state || {}

  // ========================================================
  // LECTURA ROBUSTA DE PERMISOS (FALLBACK A LOCALSTORAGE)
  // ========================================================
  let barraAcciones = selectedMenuInfo?.data?.barraAcciones

  if (!barraAcciones || barraAcciones.length === 0) {
    try {
      const menuAccionesRaw = localStorage.getItem("menuAcciones")
      if (menuAccionesRaw) {
        const menuAcciones = JSON.parse(menuAccionesRaw)
        const currentMenu = menuAcciones["ControlElectoral/RecintosElectorales"]
        if (currentMenu && currentMenu.barraAcciones) {
          barraAcciones = currentMenu.barraAcciones
        }
      }
    } catch (error) {
      console.error("Error leyendo permisos desde localStorage:", error)
    }
  }

  // ========================================================
  // MUTACIÓN PARA GUARDAR LA EDICIÓN
  // ========================================================
  const { mutateAsync: SaveEdicion, isPending: isSaving } = useMutation({
    queryKey: ["isEditingRecintoElectoral"],
    fn: async (data) => {
      const response = await api.post("/ControlElectoral/editarRecinto", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1),
  })

  // Capturamos el botón "GRABAR" dinámico
  const ejecutarAction = barraAcciones?.find((action) => action?.acccaption === "GRABAR")

  const handleSubmit = async (formData) => {
    await SaveEdicion(formData)
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        {/* BARRA DE ACCIONES SUPERIOR (BOTÓN GRABAR DINÁMICO) */}
        <Box sx={{ mb: 2 }}>
          {ejecutarAction && (
            <Tooltip title={ejecutarAction.acccaption}>
              <IconButton
                onClick={() => formRef.current?.handleSubmit()}
                disabled={isSaving}
                sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1 }}
              >
                {getIconComponent(ejecutarAction.accnameicono, ejecutarAction.acctipoico)}
              </IconButton>
            </Tooltip>
          )}
        </Box>

        {/* TÍTULO DE LA PANTALLA */}
        <div style={{ textAlign: "center", fontSize: "25px", marginBottom: "20px" }}>
          <b>Editar Recinto Electoral</b>
        </div>

        <CustomBackdrop isLoading={isSaving} />

        {/* COMPONENTE HIJO CON EL FORMULARIO (MODO EDICIÓN) */}
        <FormularioRecintoElectoral
          ref={formRef}
          initialData={rowData}
          isLoading={isSaving}
          onSubmit={handleSubmit}
          modo="editar"
        />
      </div>
    </ThemeProvider>
  )
}

export default EditarRecintoElectoral
